<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader) {
    <div class="fill ai-settings-page" menuSystem [cerrixTab]="tab" data-uiid="ai-settings">
        <div
            class="fill"
            id="ai-settings"
            menuItemId="menuItemAiSettings"
            [attr.name]="'settings.menuAiSettings' | t"
            menuicon="fa-duotone fa-solid fa-sparkles"
            menusystemsubmenu
        >
            <div class="detail-page-card">
                <div class="detail-page-card-title">{{ "settings.title" | t }}</div>
                <div class="detail-page-card-under-title">
                    <p>{{ "settings.subtitle" | t }}</p>
                </div>
            </div>

            <div
                class="fill"
                menuItemId="menuItemGeneral"
                [attr.name]="'settings.menuGeneral' | t"
                menuicon="fa-cog fad"
                menusystemitem
            >
                @if (settingsConfig[0]; as firstConfig) {
                    <div class="detail-page-card">
                        <div
                            class="detail-page-card-body padded form-group-styling cerrix-control-sm"
                        >
                            @if (firstConfig.isToggle) {
                                <cerrix-toggle-info
                                    [dataUiid]="firstConfig.name"
                                    [title]="firstConfig.name"
                                    [description]="firstConfig.description"
                                    [descriptionClick]="firstConfig.descriptionClick"
                                    [toggleInfo]="firstConfig.toggleInfo"
                                    [initialValue]="firstConfig.boolValue"
                                    [beforeChange]="firstConfig.beforeChange"
                                    (valueChange)="firstConfig.valueChange($event)"
                                ></cerrix-toggle-info>
                            }
                        </div>
                    </div>
                }

                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ "settings.settingsTitle" | t }}</div>
                </div>

                @for (config of settingsConfig.slice(1); track config) {
                    <div class="detail-page-card">
                        <div
                            class="detail-page-card-body padded form-group-styling cerrix-control-sm"
                        >
                            @if (config.isToggle) {
                                <cerrix-toggle-info
                                    [dataUiid]="config.name"
                                    [title]="config.name"
                                    [description]="config.description"
                                    [descriptionClick]="config.descriptionClick"
                                    [toggleInfo]="config.toggleInfo"
                                    [initialValue]="config.boolValue"
                                    [beforeChange]="config.beforeChange"
                                    (valueChange)="config.valueChange($event)"
                                ></cerrix-toggle-info>
                            } @else if (config.isDropdown) {
                                <div class="detail-page-card" [attr.data-uiid]="config.name">
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="title" data-uiid="toggle-title">
                                                {{ config.name }}
                                            </div>
                                            <div
                                                class="description"
                                                data-uiid="toggle-description"
                                                [innerHTML]="config.description"
                                            ></div>
                                        </div>
                                        <div class="col-6">
                                            <cerrix-select
                                                [dataUiid]="config.name"
                                                [getDataMethod]="config.dropdownOptions"
                                                [value]="config.dropdownValue"
                                                (valueChange)="config.valueChange($event)"
                                                bindLabel="Name"
                                                bindValue="ID"
                                            ></cerrix-select>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
}

<ng-template #textPopupTemplate>
    <div class="prompt-text" [innerHTML]="'settings.termsText' | t"></div>
</ng-template>
